import { z } from "zod";

/** Bump when the checkbox wording changes. */
export const DIGITAL_CONSENT_VERSION = "dc-2026-10-10";
/** Bump when the Terms & Conditions change materially. */
export const TERMS_VERSION = "terms-2026-10-04";
export const TERMS_LAST_UPDATED = "4 October 2026";

/**
 * The only thing a customer is asked to agree to at checkout. Stored verbatim
 * against each purchase so the record matches what was actually shown.
 */
export const CHECKOUT_AGREEMENT_TEXT =
  "By continuing you agree to our Terms & Conditions.";

/**
 * The express digital-content request and acknowledgement. It is no longer put
 * in front of the customer as its own tick-box: it lives in section 10 of the
 * Terms & Conditions, which the customer agrees to at checkout, and is quoted
 * there.
 */
export const DIGITAL_CONSENT_TEXT =
  "I request immediate access to the digital content and expressly consent to the supply beginning during the 14-day cancellation period. I acknowledge that once the digital content begins to be supplied, I will lose my statutory right to cancel.";

export const digitalConsentSchema = z
  .object({
    accepted: z.literal(true),
    version: z.literal(DIGITAL_CONSENT_VERSION),
  })
  .optional();

export type DigitalConsentInput = z.infer<typeof digitalConsentSchema>;

export function buildDigitalConsent(): NonNullable<DigitalConsentInput> {
  return { accepted: true, version: DIGITAL_CONSENT_VERSION };
}

export const MISSING_CONSENT_MESSAGE =
  "We could not confirm your agreement to the Terms & Conditions. Please try again, or email info@recoverytrauma.com.";
